import { useEffect, useState } from 'react';

function buildCountdownState(targetDate) {
  const fallbackTarget = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
  const resolvedTarget = Number.isNaN(targetDate.getTime())
    ? fallbackTarget
    : targetDate;
  const distance = Math.max(0, resolvedTarget.getTime() - Date.now());

  const days = Math.floor(distance / (24 * 60 * 60 * 1000));
  const hours = Math.floor((distance % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  const minutes = Math.floor((distance % (60 * 60 * 1000)) / (60 * 1000));
  const seconds = Math.floor((distance % (60 * 1000)) / 1000);

  return {
    days: String(days).padStart(2, '0'),
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
  };
}

export default function useCountdown(targetDateString) {
  const targetDate = new Date(targetDateString);
  const [countdown, setCountdown] = useState(() => buildCountdownState(targetDate));

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setCountdown(buildCountdownState(targetDate));
    }, 1000);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [targetDateString]);

  return countdown;
}
